import { useMemo, useState } from 'react';
import { useCompanyStatesQuery, useCitiesByStateMutation } from 'services/api/companies';

export default function useStatesAndCitiesSelect() {
  const { data: statesData, isLoading: isStatesLoading } = useCompanyStatesQuery();
  const [citiesByStateTrigger,
    { data: citiesData }] = useCitiesByStateMutation();

  const stateOptions = useMemo(
    () => statesData?.map(
      (state) => ({ value: state.id, label: state.uf }),
    ),
    [statesData],
  );

  const cityOptions = useMemo(
    () => citiesData?.map(
      (city) => ({ value: city.id, label: city.nome }),
    ),
    [citiesData],
  );

  const [cityValue, setCityValue] = useState<number>();
  const [stateValue, setStateValue] = useState<number>();

  const onCityChange = (newValue: React.SetStateAction<number | undefined>) => {
    setCityValue(newValue);
  };

  const onStateChange = (newValue: React.SetStateAction<number | undefined>) => {
    if (newValue === stateValue) return;

    setStateValue(newValue);
    setCityValue(undefined);

    if (newValue) {
      citiesByStateTrigger({ stateId: newValue as number });
    }
  };

  return {
    stateOptions,
    cityOptions,
    citiesByStateTrigger,
    isStatesLoading,
    cityValue,
    stateValue,
    onCityChange,
    onStateChange,
  };
}
